import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminNetworks,
  initializeRateAdminNetworksScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminNetworks,
  saveNetworksTableState,
} from "../../../redux/actions/RateAdmin/rateadminNetworks";
import RateAdminNetworks from '../../../component/RateAdmin/RateAdminNetworks';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
function RateAdminNetworksScreen(props) {
  const {
    fetchRateAdminNetworks,
    initRateAdminNetworksScreen,
    showPageLevelLoader,
    rateAdminNetworksListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminNetworks,
    isRateAdminNetworksExportError,
    isRateAdminNetworksExportSuccess,
    isLoading,
    savedTableState,
    saveNetworksTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initRateAdminNetworksScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminNetworks(savedParams);
    } else {
      fetchRateAdminNetworks({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchRateAdminNetworks(props);
  };

  const handleTableStateChange = (tableState) => {
    saveNetworksTableState(tableState);
  };

  const handleCreateRateAdminNetworks = () => {
    navigate(APP_URLS.RATEADMIN_NETWORK.CREATE);
  }
  const editRateAdminNetworksRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_NETWORK.EDIT, {
      id,
    });
    navigate(path);
  };
  const rateAdminNetworks = {
    handleCreateRateAdminNetworks,
    exportRateAdminNetworks,
    isRateAdminNetworksExportError,
    isRateAdminNetworksExportSuccess,
    editRateAdminNetworksRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchRateAdminNetworkss: loadLazyData,
    tableData: {
      columns: rateAdminNetworksListview?.columns,
      rows: rateAdminNetworksListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminNetworks
        {...rateAdminNetworks}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminNetworksScreen: () => dispatch(initializeRateAdminNetworksScreen()),
    fetchRateAdminNetworks: (payload) => dispatch(fetchRateAdminNetworks(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminNetworks: (payload) => dispatch(exportRateAdminNetworks(payload)),
    saveNetworksTableState: (payload) => dispatch(saveNetworksTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminNetworksCreateSuccess: selectFromRateAdminNetworksReducer(
      state,
      "isRateAdminNetworksCreateSuccess"
    ),
    rateAdminNetworksListview: selectFromRateAdminNetworksReducer(
      state,
      "rateAdminNetworksListview"
    ),
    showPageLevelLoader: selectFromRateAdminNetworksReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminNetworksReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRateAdminNetworksReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminNetworksReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminNetworksExportError: selectFromRateAdminNetworksReducer(
      state,
      "isRateAdminNetworksExportError"
    ),
    isRateAdminNetworksExportSuccess: selectFromRateAdminNetworksReducer(
      state,
      "isRateAdminNetworksExportSuccess"
    ),
    savedTableState: selectFromRateAdminNetworksReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminNetworksReducer = (state, path) => {
  return selectRateAdminNetworksReducer(state)[path];
};

const selectRateAdminNetworksReducer = ({ rateadminNetworksReducer }) => {
  return rateadminNetworksReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(RateAdminNetworksScreen);
